import axios from 'axios';
import { WEB_UI_API_BASE_URL } from 'src/config';

export type WebUiApiRequest = {
  service: string;
  access?: 'get' | 'set' | 'add' | 'remove';
  command: string;
  parameters?: unknown;
};

const baseUrl = WEB_UI_API_BASE_URL?.replace(/\/+$/, '') ?? '';

export async function postWebUiApi<T>(
  request: WebUiApiRequest,
  init?: { signal?: AbortSignal },
): Promise<T> {
  const res = await axios.post(`${baseUrl}/api`, request, {
    signal: init?.signal,
  });

  if (res.status !== 200) {
    throw new Error(`Web-UI API error: ${res.status}`);
  }

  return res.data as T;
}
